import React, { useState, useEffect } from "react";
import translate from "../../../translations/translations.wrapper.jsx";
import "./comments.scss";
import spinner from "../../../../assets/spinner.svg";
import { useDispatch, useSelector } from "react-redux";
import * as reduxSelectors from "../../../store/application.reducers";
import NewCommentsList from "components/taskdetails-remake/panels/comments/NewCommentsList.component";
import NewCommentsInput from "components/taskdetails-remake/panels/comments/NewCommentsInput.component";
import { NewCommentsPanelProps } from "types/comments";
import NewCommentsProfile from "components/taskdetails-remake/panels/comments/NewCommentsProfile.component";
import NewCommentsValidation from "components/taskdetails-remake/panels/comments/NewCommentsValidation.component";
import { changeUnsavedComment, getTaskCommentsData } from "components/taskdetails-remake/taskDetails.action";
import { COMMENTS_INPUT_MAX_LENGTH } from "utils/constants";

const NewCommentsPanel: React.FC<NewCommentsPanelProps> = (props) => {
    const [currentComment, setCurrentComment] = useState<string | null>(null);
    const [savingComment, setSavingComment] = useState(false);
    const commentsCount = useSelector(reduxSelectors.getTaskCommentsCount);
    const isLoading = useSelector(reduxSelectors.getTaskCommentsLoadingStatus);
    const currentUser = useSelector(reduxSelectors.getUsersLoggedInData);
    const taskUnsavedComment = useSelector(reduxSelectors.getTaskUnsavedComment);
    const dispatch = useDispatch();

    useEffect(() => {
        resetCommentField();
        requestData(props.taskId);
    }, [props.taskId]);

    useEffect(() => {
        if (props.shouldHandleSave) {
            addNewComment();
        }
    }, [props.shouldHandleSave]);

    useEffect(() => {
        if (props.shouldHandleDiscard) {
            resetCommentField();
        }
    }, [props.shouldHandleDiscard]);

    useEffect(() => {
        const search = setTimeout(() => {
            updateTaskUnsavedComment(currentComment);
        }, 1000);
        return () => clearTimeout(search);
    }, [currentComment]);

    const requestData = (taskId: string) => {
        dispatch(getTaskCommentsData(taskId));
    };

    const resetCommentField = () => {
        setCurrentComment(null);
        setSavingComment(false);
        props.onCommentChange(false);
    };

    const addNewComment = () => {
        if (isAddCommentDisabled()) {
            return;
        }
        setSavingComment(true);
        setCurrentComment(null);
        if (props.addCommentHandler) {
            props.addCommentHandler(props.taskId, currentComment, resetCommentField);
        }
    };

    const isAddCommentDisabled = () => {
        return currentComment === null || savingComment || currentComment.length > 500 || currentComment.length === 0;
    };

    const updateTaskUnsavedComment = (comment: string) => {
        if (comment === taskUnsavedComment) {
            return;
        }

        dispatch(changeUnsavedComment(comment));
    };

    const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        let comment = event.target.value;

        if (comment !== currentComment) {
            setCurrentComment(comment);
        }
        props.onCommentChange(comment !== currentComment && comment !== "");
    };

    const currentCommentsCount = isLoading ? props.initialCommentsCount : commentsCount;

    return (
        <div className="grid-comments-panel">
            <div className="grid-panel-header">
                <strong>
                    {props.translate("taskDetail.notesAndComments")}
                    {currentCommentsCount > 0 ?
                        <span> ({currentCommentsCount <= 99 ? currentCommentsCount : "99+"})</span> : null
                    }
                </strong>
            </div>

            <NewCommentsList translate={props.translate} />
            {!(props.readOnly) &&
                <div className="new-comment-area">
                    <NewCommentsProfile
                        connectUserId={currentUser.connectUserId}
                        userName={currentUser.fullName} />
                    <div
                        className={`new-comment-input-and-save ${currentComment?.length > COMMENTS_INPUT_MAX_LENGTH ? "comment-too-long" : ""} col-md-11 align-self-stretch`}>
                        <div className="input-and-save-wrapper">
                            <NewCommentsInput id="comments"
                                              value={currentComment ? currentComment : ""}
                                              placeholder={props.translate("taskDetail.sendComment")}
                                              onChange={onChange}
                                              disabled={false}
                            />
                            {savingComment ?
                                <img src={spinner}
                                     alt={"saving"}
                                     className={"saving-spinner"} /> :
                                <div className="send-comment-btn" onClick={addNewComment}>
                                        <span
                                            className={"vismaicon vismaicon-paperplane " + (isAddCommentDisabled() ? "disabled" : "")}></span>
                                </div>
                            }
                        </div>
                        <NewCommentsValidation comment={currentComment}
                                               translate={props.translate}>

                        </NewCommentsValidation>
                    </div>
                </div>
            }
        </div>
    );
};

const withTranslations = translate(NewCommentsPanel);

export default withTranslations;